export const version = "json-wallets/5.0.11";
//# sourceMappingURL=_version.js.map